export const SIGNER_PICKER_TRANSLATION_KEYS = {
  mandatoryRequired: 'jbp-acknowledgment-signer-picker--mandatory-required',
  participation: 'jbp-acknowledgment-signer-picker--participation',
  mandatory: 'jbp-acknowledgment-signer-picker--mandatory',
  optional: 'jbp-acknowledgment-signer-picker--optional',
  cancel: 'jbp-acknowledgment-signer-picker--cancel',
  addMandatory: 'jbp-acknowledgment-signer-picker--add-mandatory',
  addOptional: 'jbp-acknowledgment-signer-picker--add-optional',
  addSigner: 'jbp-acknowledgment-signer-picker--add-signer',
  addingPbm: 'jbp-acknowledgment-signer-picker--adding-pbm',
  addingPartner: 'jbp-acknowledgment-signer-picker--adding-partner',
} as const
